import _ from 'lodash';

import colorbrewer from '../core/tools/colorbrewer';
import Leaflet from './Leaflet';
// import 'mapbox.js';

const COLOR_SCHEMES = [
    'Blues',
    'Reds',
    'Greens',
    'Purples',
    'Oranges',
    'BuPu',
    'GnBu',
    'YlOrBr',
    'PuRd',
    'YlGn',
    'PuBuGn',
    'YlGnBu'
];

class TradeAreaLayer {
    constructor (currentMap) {
        this.layer = new Leaflet.D3Layer({
            map: currentMap,
            // cache: true
            showAll: true,
            autofocus: false,
            uniqueField: ['IdLoja', 'Raio'],
            incremental: true,
            bellow: true,
            tag: {
                property: 'ToBreak',
                size: 9,
                box: true,
                colorize: true,
                align: 'southWest',
                mask (value) {
                    return L.GeometryUtil.readableDistance(value, true);
                }
            },
            symbology: {
                type: 'uniq',
                property: 'Raio',
                values: [{
                    value: 1,
                    style: {
                        fillColor: '#e74c3c',
                        fillOpacity: 0.3,
                        color: '#e74c3c',
                        opacity: 1,
                        weight: 2,
                        clickable: false
                    }
                }, {
                    value: 2,
                    style: {
                        fillColor: '#e67e22',
                        fillOpacity: 0.3,
                        color: '#e67e22',
                        opacity: 1,
                        weight: 2,
                        clickable: false
                    }
                }, {
                    value: 3,
                    style: {
                        fillColor: '#f1c40f',
                        fillOpacity: 0.3,
                        color: '#f1c40f',
                        opacity: 1,
                        weight: 2,
                        clickable: false
                    }
                }]
            }
        });

        const originalGetStyle = this.layer._getStyle.bind(this.layer);

        this.layer._getStyle = (feature) => {
            const style = originalGetStyle(feature);
            const color = this._getStoreColor(feature);

            if (color) {
                style.fillColor = color;
                style.color = color;
            }

            return style;
        };

        return this.layer;
    }

    _getStoreColor (feature) {
        const scheme = this._getStoreScheme(feature.properties.IdLoja);

        if (!scheme) {
            return null;
        }

        const palette = colorbrewer[scheme] && colorbrewer[scheme][4];
        const raio = Number(feature.properties.Raio);

        if (!palette || !(raio >= 1 && raio <= 3)) {
            return null;
        }

        return palette[4 - raio];
    }

    _getStoreScheme (idLoja) {
        if (_.isNil(idLoja)) {
            return null;
        }

        const index = _(this.layer.getFeatures())
            .map(f => f.properties.IdLoja)
            .uniq()
            .indexOf(idLoja);

        if (index < 0) {
            return null;
        }

        return COLOR_SCHEMES[index % COLOR_SCHEMES.length];
    }
}

export default TradeAreaLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/TradeAreaLayer.js